"use client";

import { RefObject, useEffect, useState } from "react";

import UnusedTicketsBar from "@/app/(custom-header)/botb-pass-members-home/components/UnusedTicketsBar";

interface FloatingUnusedTicketsBarProps {
  observeRef: RefObject<HTMLElement>;
  hasUnusedTickets?: boolean;
}

export default function FloatingUnusedTicketsBar({
  observeRef,
  hasUnusedTickets = false,
}: FloatingUnusedTicketsBarProps) {
  const [isFloating, setIsFloating] = useState(false);

  useEffect(() => {
    const target = observeRef.current;
    if (!target) return;

    const observer = new IntersectionObserver(([entry]) => setIsFloating(!entry.isIntersecting), {
      threshold: 0,
      // Treat the bar as "out of view" once it slides under the sticky header.
      rootMargin: "-80px 0px 0px 0px",
    });

    observer.observe(target);
    return () => observer.disconnect();
  }, [observeRef]);

  return (
    <div
      className={`fixed z-[100] !top-auto bottom-4 lg:bottom-auto lg:!top-1/2 left-[18px] right-[18px] lg:left-auto lg:right-10 lg:w-[360px] transition-[transform,visibility] duration-300 ${
        isFloating
          ? "visible translate-y-0 lg:-translate-y-1/2"
          : "invisible pointer-events-none translate-y-[calc(100%+16px)] lg:translate-y-[-50%] lg:translate-x-[calc(100%+40px)]"
      }`}>
      <UnusedTicketsBar hasUnusedTickets={hasUnusedTickets} />
    </div>
  );
}
